var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43922 7.47927C6.70431 7.1258 6.63268 6.62436 6.27922 6.35927C5.92576 6.09417 5.42431 6.1658 5.15922 6.51927L2.39922 10.1993L5.15922 13.8793C5.42431 14.2327 5.92576 14.3044 6.27922 14.0393C6.63268 13.7742 6.70431 13.2727 6.43922 12.9193L4.99922 10.9993H25.3992C25.841 10.9993 26.1992 10.6411 26.1992 10.1993C26.1992 9.75744 25.841 9.39927 25.3992 9.39927H4.99922L6.43922 7.47927ZM23.3992 18.9993H2.99922C2.55739 18.9993 2.19922 18.6411 2.19922 18.1993C2.19922 17.7574 2.55739 17.3993 2.99922 17.3993H23.3992L21.9592 15.4793C21.6941 15.1258 21.7658 14.6244 22.1192 14.3593C22.4727 14.0942 22.9741 14.1658 23.2392 14.5193L25.9992 18.1993L23.2392 21.8793C22.9741 22.2327 22.4727 22.3044 22.1192 22.0393C21.7658 21.7742 21.6941 21.2727 21.9592 20.9193L23.3992 18.9993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferArrows);
export default __webpack_public_path__ + "static/media/transfer-arrows.59693dc6e9624dea192aa172d8f5be92.svg";
export { ForwardRef as ReactComponent };